var _defs, _defs2, _use, _use2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantMessages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190.7 103.6"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "instant-messages_svg__reuse-0",
    d: "M188.2 36.7L157 1.8l-.1-.1-.2-.1a7.2 7.2 0 00-3.8-1.5V0l-35.5.7a9.8 9.8 0 00-1.1.1 25.7 25.7 0 00-4.6 1 12 12 0 00-4 2.3l-38.2 32-.5.4a10.6 10.6 0 00-4.5 6.5L53.6 98.3a4.3 4.3 0 004.6 5.3h118.4a6.4 6.4 0 006.3-5.2l7.7-55.5a6.6 6.6 0 00-2.4-6.2z",
    className: "instant-messages_svg__a"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".instant-messages_svg__a{fill:#222}.instant-messages_svg__b{fill:#02385c}"))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#instant-messages_svg__reuse-0",
    className: "instant-messages_svg__a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#instant-messages_svg__reuse-0",
    className: "instant-messages_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.7 38.5l-27 .2 37-31a5.7 5.7 0 011.8-1 20.5 20.5 0 013.5-.8 4.4 4.4 0 01.6 0l25.5-.6-39 31.2a11.8 11.8 0 00-2.4 2zm-41.5 60a.2.2 0 01-.2-.2l10.5-54.5 28.7-.2-10 55z",
    className: "instant-messages_svg__b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M185.4 42.9a2.3 2.3 0 00-1-2.1v-.2h-.2L153 5.5a3.6 3.6 0 00-3.7 0l-43.6 34.8-.1.1a4.1 4.1 0 00-2 2.7l-9.9 55.1a.2.2 0 00.2.2h83.5a.2.2 0 00.3-.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8 5.4h-38a2.6 2.6 0 010-5.3h38a2.6 2.6 0 110 5.3zm-54.1 98.1h-38a2.6 2.6 0 010-5.3h38a2.6 2.6 0 010 5.3zm12.1-61.7h-35a2.6 2.6 0 110-5.2h35a2.6 2.6 0 110 5.2z",
    className: "instant-messages_svg__a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9 31.3H45.5a2.6 2.6 0 110-5.2h18.4a2.6 2.6 0 010 5.2z",
    className: "instant-messages_svg__b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.9 60.8a4 4 0 114.5-3.4 4 4 0 01-4.5 3.4zm40.9 5.7a4 4 0 114.5-3.4 4 4 0 01-4.5 3.4z",
    className: "instant-messages_svg__a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M134 70.9a1 1 0 00-1.2 1c-.1 6.1 5.7 12 13.6 13 7.8 1.1 15-2.9 16.6-8.9a1 1 0 00-1-1.2z"
  })));
}
export default SvgInstantMessages;